import axios from 'axios';

const config = {
	headers: {
		'x-access-token': sessionStorage.token,
	},
};

let host = 'http://localhost:8000/';
if (process.env.NODE_ENV === 'production') {
	host = 'https://reale-server.herokuapp.com/';
}
const url = `${host}api/auctionlocations`;

const getAllAuctionLocations = () => axios.get(url, config);

const getAuctionLocation = (id: string) => axios.get(`${url}/${id}`, config);

const getMultipleAuctionLocation = (obj: any) =>
	axios.post(`${url}/multi`, obj, config);

// const addAuction = (obj: any) => {
// 	return axios.post(url, obj, config());
// };

// const updateAuction = (id: string, obj: any) => {
// 	return axios.put(url + '/' + id, obj, config());
// };

// const deleteAuction = (id: string) => {
// 	return axios.delete(url + '/' + id, config());
// };

// //ONLY FOR LANDING PAGE - OPEN TO ALL
// const getLandingJob = (id) => {
// 	return axios.get(url2 + '/' + id);
// };

const auctionLocationsUtils = {
	getAllAuctionLocations,
	getAuctionLocation,
	getMultipleAuctionLocation,
};
export default auctionLocationsUtils;

// export default {

// };
